import { StudentDataParams } from '@app/core/services/http/my-world-http.service';

import {
  LoadStudentByTokenActionPayload,
  UpdateBiographyStudentPayload
} from './student.model';

export class LoadStudentByTokenAction {
  static readonly type = '[Student] Load student by token';
  constructor(public payload: LoadStudentByTokenActionPayload = {}) {}
}

export class LoadStudentByClassAndGradeAction {
  static readonly type = '[Student] Load student by class and grade';
  constructor(public payload: StudentDataParams) {}
}

export class UpdateStudentBiographyAction {
  static readonly type = '[Student] Update biography student';
  constructor(public payload: UpdateBiographyStudentPayload) {}
}
